import { useEffect, useMemo, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import './ClientsDetails.css'
import Modal from '../components/Modal/Modal'
import BigModal from '../components/Modal/BigModal'


const API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/getClientDetails'
const UPDATE_CLIENT_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/updateClient'
const EDIT_CONTACT_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/editContact'
const EDIT_ADDRESS_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/editAddress'
const SEARCH_PRODUCTS_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/searchProducts'
const SAVE_ORDER_FULL_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/newOrder'
const GET_PRODUCTS_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/getProducts'
const GET_ORDER_STATUS_HISTORY_API_URL = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/getOrderStatusHistory'

const ORDER_STATUSES = [
    'solicitare',
    'ofertat',
    'acceptat',
    'asteptare_plata',
    'comanda_furnizor',
    'pregatire_colet',
    'expediat',
    'finalizat',
    'refuzat'
]
const ORDER_STATUS_LABELS = {
    solicitare: 'Solicitare',
    ofertat: 'Ofertat',
    acceptat: 'Acceptat',
    asteptare_plata: 'Așteptare plată',
    comanda_furnizor: 'Comandă furnizor',
    pregatire_colet: 'Pregătire colet',
    expediat: 'Expediat',
    finalizat: 'Finalizat',
    refuzat: 'Refuzat'
}

function ClientsDetails() {
    const navigate = useNavigate()
    const { clientSlug } = useParams()

    const [client, setClient] = useState(null)
    const [activeFilter, setActiveFilter] = useState('toate')
    const [orderSearch, setOrderSearch] = useState('')
    const [dateRange, setDateRange] = useState({ start: '', end: '' })
    const [isDatePickerOpen, setIsDatePickerOpen] = useState(false)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')
    const logoFileInputRef = useRef(null)
    const [isEditClientOpen, setIsEditClientOpen] = useState(false)
    const [editClientForm, setEditClientForm] = useState({
        logo: '',
        nume: '',
        cui: '',
        website: '',
        note: ''
    })
    const [savingClient, setSavingClient] = useState(false)

    const [isEditContactsOpen, setIsEditContactsOpen] = useState(false)
    const [editContactsForm, setEditContactsForm] = useState([])
    const [savingContacts, setSavingContacts] = useState(false)

    const [isEditAddressesOpen, setIsEditAddressesOpen] = useState(false)
    const [editAddressesForm, setEditAddressesForm] = useState([])
    const [savingAddresses, setSavingAddresses] = useState(false)
    const [isNewOrderOpen, setIsNewOrderOpen] = useState(false)
    const [savingOrder, setSavingOrder] = useState(false)
    const [productSearchLoading, setProductSearchLoading] = useState(false)
    const [allProducts, setAllProducts] = useState([])
    const [productSearchResults, setProductSearchResults] = useState({})
    const [offerStatusDropdown, setOfferStatusDropdown] = useState(null)
    const offerStatusDropdownRef = useRef(null)
    const [calendarMonth, setCalendarMonth] = useState(new Date())
    const [collapsedSupplierSections, setCollapsedSupplierSections] = useState({})
    const [newOrderForm, setNewOrderForm] = useState({
        numeComanda: '',
        data: new Date().toISOString().slice(0, 10),
        ora: new Date().toTimeString().slice(0, 5),
        contactId: '',
        adresaId: '',
        notite: '',
        produse: []
    })
    async function getOrderHistoryDates(offer) {
        if (!offer.uuid) {
            return {
                latest_status_date: '',
                solicitare_status_date: offer.solicitare_data || ''
            }
        }

        try {
            const response = await fetch(
                `${GET_ORDER_STATUS_HISTORY_API_URL}?uuid=${encodeURIComponent(offer.uuid)}`,
                {
                    method: 'GET'
                }
            )

            const data = await response.json()

            if (!response.ok || !data.success) {
                throw new Error(
                    data.message || 'Nu am putut încărca istoricul comenzii.'
                )
            }

            const history = Array.isArray(data.history)
                ? data.history
                : []

            const solicitareHistory = history.find(
                (historyItem) => historyItem.status === 'solicitare'
            )

            const currentStatusHistory = [...history]
                .reverse()
                .find(
                    (historyItem) =>
                        historyItem.status === data.currentStatus
                )

            const latestHistory = [...history].sort(
                (firstItem, secondItem) =>
                    String(secondItem.created_at || '').localeCompare(
                        String(firstItem.created_at || '')
                    )
            )[0]

            return {
                latest_status_date:
                    currentStatusHistory?.created_at ||
                    latestHistory?.created_at ||
                    offer.solicitare_data ||
                    '',

                solicitare_status_date:
                    solicitareHistory?.created_at ||
                    offer.solicitare_data ||
                    ''
            }
        } catch (err) {
            console.error(
                `GET ORDER HISTORY ERROR ${offer.uuid}:`,
                err
            )

            return {
                latest_status_date: offer.solicitare_data || '',
                solicitare_status_date: offer.solicitare_data || ''
            }
        }
    }
    useEffect(() => {
        getClient()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientSlug])
    async function getClient() {
        try {
            setLoading(true)
            setError('')

            const url = `${API_URL}?slug=${encodeURIComponent(clientSlug)}`

            console.log('CLIENT SLUG:', clientSlug)
            console.log('CLIENT DETAILS URL:', url)

            const response = await fetch(url, {
                method: 'GET'
            })

            const text = await response.text()

            console.log('STATUS:', response.status)
            console.log('RAW RESPONSE:', text)

            if (!response.ok) {
                throw new Error(`Request failed: ${response.status}`)
            }
            const data = JSON.parse(text)


            if (!data.success) {
                throw new Error(data.message || 'Client not found')
            }

            const offers = Array.isArray(data.oferte)
                ? data.oferte
                : []

            const offersWithHistory = await Promise.all(
                offers.map(async (offer) => {
                    const historyDates = await getOrderHistoryDates(offer)

                    return {
                        ...offer,
                        ...historyDates
                    }
                })
            )

            setClient({
                ...data.client,
                contacte: data.contacte || [],
                adrese: data.adrese || [],
                oferte: offersWithHistory
            })
        } catch (err) {
            console.error('GET CLIENT DETAILS ERROR:', err)
            setError('Nu am putut încărca datele clientului.')
        } finally {
            setLoading(false)
        }
    }

    function getInitials(name) {
        return String(name || '?')
            .split(' ')
            .filter(Boolean)
            .slice(0, 2)
            .map((word) => word.charAt(0))
            .join('')
            .toUpperCase()
    }
    function getOrderNumber(offer) {
        const orderId = Number(offer.id)

        if (!Number.isFinite(orderId)) {
            return '-'
        }

        return 1000 + orderId
    }
    function formatDate(dateString) {
        if (!dateString) {
            return '-'
        }

        const cleanDate = String(dateString)
            .replace('T', ' ')
            .replace('.000Z', '')
            .replace('Z', '')

        const [datePart, timePart = '00:00:00'] = cleanDate.split(' ')
        const [year, month, day] = datePart.split('-')
        const [hour = '00', minute = '00'] = timePart.split(':')

        return `${day}.${month}.${year} • ${hour}.${minute}`
    }

    const filteredOffers = useMemo(() => {
        const offers = client?.oferte || []
        const searchValue = orderSearch.trim().toLowerCase()

        return offers.filter((offer) => {
            const matchesStatus =
                activeFilter === 'toate' ||
                (activeFilter === 'arhivate' && ['finalizat', 'refuzat'].includes(offer.status)) ||
                offer.status === activeFilter

            const matchesSearch =
                !searchValue ||
                [
                    offer.nume_comanda,
                    getOrderNumber(offer),
                    offer.status,
                    ORDER_STATUS_LABELS[offer.status]
                ]
                    .filter(Boolean)
                    .join(' ')
                    .toLowerCase()
                    .includes(searchValue)

            const offerDate = offer.solicitare_data
                ? new Date(offer.solicitare_data).toISOString().slice(0, 10)
                : ''

            const matchesDate =
                (!dateRange.start || offerDate >= dateRange.start) &&
                (!dateRange.end || offerDate <= dateRange.end)

            return matchesStatus && matchesSearch && matchesDate
        })
    }, [client, activeFilter, orderSearch, dateRange])

    if (loading) {
        return <section className="clientDetailsPage">Se încarcă clientul...</section>
    }

    if (error) {
        return <section className="clientDetailsPage">{error}</section>
    }

    if (!client) {
        return <section className="clientDetailsPage">Client negăsit.</section>
    }
    function openEditClientModal() {
        setEditClientForm({
            logo: client.logo || '',
            nume: client.nume || '',
            cui: client.cui || '',
            website: client.website || '',
            note: client.note || ''
        })

        setIsEditClientOpen(true)
    }

    async function saveClient() {
        try {
            setSavingClient(true)

            const payload = {
                id: client.id,
                logo: editClientForm.logo,
                logoUpload: editClientForm.logoUpload || null,
                nume: editClientForm.nume,
                cui: editClientForm.cui,
                website: editClientForm.website,
                note: editClientForm.note
            }

            const response = await fetch(UPDATE_CLIENT_API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })

            const data = await response.json()

            if (!response.ok || !data.success) {
                throw new Error(data.message || 'Update failed')
            }

            await getClient()

            setIsEditClientOpen(false)

            setIsEditClientOpen(false)
        } catch (err) {
            console.error('SAVE CLIENT ERROR:', err)
            alert('Nu am putut salva clientul.')
        } finally {
            setSavingClient(false)
        }
    }

    function handleLocalLogoChange(event) {
        const file = event.target.files?.[0]

        if (!file) {
            return
        }

        if (!file.type.startsWith('image/')) {
            alert('Te rog încarcă o imagine.')
            event.target.value = ''
            return
        }

        const reader = new FileReader()

        reader.onload = () => {
            setEditClientForm((prev) => ({
                ...prev,
                logo: reader.result,
                logoUpload: {
                    fileName: file.name,
                    contentType: file.type,
                    fileContent: reader.result
                }
            }))
        }

        reader.readAsDataURL(file)
    }

    // edit contact

    function openEditContactsModal() {
        setEditContactsForm(
            (client.contacte || []).map((contact) => ({
                id: contact.id,
                nume: contact.nume || '',
                functie: contact.functie || '',
                email: contact.email || '',
                telefon: contact.telefon || '',
                deleted: false
            }))
        )

        setIsEditContactsOpen(true)
    }

    function updateContactForm(index, field, value) {
        setEditContactsForm((prev) =>
            prev.map((contact, contactIndex) =>
                contactIndex === index
                    ? {
                        ...contact,
                        [field]: value
                    }
                    : contact
            )
        )
    }

    function addContactForm() {
        setEditContactsForm((prev) => [
            ...prev,
            {
                id: null,
                nume: '',
                functie: '',
                email: '',
                telefon: '',
                deleted: false
            }
        ])
    }

    function deleteContactForm(index) {
        setEditContactsForm((prev) =>
            prev.map((contact, contactIndex) =>
                contactIndex === index
                    ? {
                        ...contact,
                        deleted: true
                    }
                    : contact
            )
        )
    }

    async function saveContacts() {
        try {
            setSavingContacts(true)

            const payload = {
                clientId: client.id,
                contacte: editContactsForm
                    .filter((contact) => !contact.deleted)
                    .map((contact) => ({
                        id: contact.id || null,
                        nume: contact.nume || '',
                        functie: contact.functie || '',
                        email: contact.email || '',
                        telefon: contact.telefon || ''
                    }))
            }

            const response = await fetch(EDIT_CONTACT_API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })

            const data = await response.json()

            if (!response.ok || !data.success) {
                throw new Error(data.message || 'Update contacts failed')
            }

            setClient((prev) => ({
                ...prev,
                contacte: data.contacte || []
            }))

            setIsEditContactsOpen(false)
        } catch (err) {
            console.error('SAVE CONTACTS ERROR:', err)
            alert('Nu am putut salva contactele.')
        } finally {
            setSavingContacts(false)
        }
    }

    // edit address

    function openEditAddressesModal() {
        setEditAddressesForm(
            (client.adrese || []).map((adresa) => ({
                id: adresa.id,
                nume: adresa.nume || '',
                adresa: adresa.adresa || '',
                deleted: false
            }))
        )

        setIsEditAddressesOpen(true)
    }

    function updateAddressForm(index, field, value) {
        setEditAddressesForm((prev) =>
            prev.map((adresa, addressIndex) =>
                addressIndex === index
                    ? {
                        ...adresa,
                        [field]: value
                    }
                    : adresa
            )
        )
    }

    function addAddressForm() {
        setEditAddressesForm((prev) => [
            ...prev,
            {
                id: null,
                nume: '',
                adresa: '',
                deleted: false
            }
        ])
    }

    function deleteAddressForm(index) {
        setEditAddressesForm((prev) =>
            prev.map((adresa, addressIndex) =>
                addressIndex === index
                    ? {
                        ...adresa,
                        deleted: true
                    }
                    : adresa
            )
        )
    }

    async function saveAddresses() {
        try {
            setSavingAddresses(true)

            const payload = {
                clientId: client.id,
                adrese: editAddressesForm
                    .filter((adresa) => !adresa.deleted)
                    .map((adresa) => ({
                        id: adresa.id || null,
                        nume: adresa.nume || '',
                        adresa: adresa.adresa || ''
                    }))
            }

            const response = await fetch(EDIT_ADDRESS_API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })

            const data = await response.json()

            if (!response.ok || !data.success) {
                throw new Error(data.message || 'Update addresses failed')
            }

            setClient((prev) => ({
                ...prev,
                adrese: data.adrese || []
            }))

            setIsEditAddressesOpen(false)
        } catch (err) {
            console.error('SAVE ADDRESSES ERROR:', err)
            alert('Nu am putut salva adresele.')
        } finally {
            setSavingAddresses(false)
        }
    }

    // new comanda 
    function openNewOrderModal() {
        setNewOrderForm({
            numeComanda: '',
            data: new Date().toISOString().slice(0, 10),
            ora: new Date().toTimeString().slice(0, 5),
            contactId: client.contacte?.[0]?.id || '',
            adresaId: client.adrese?.[0]?.id || '',
            notite: '',
            produse: []
        })

        setProductSearchResults({})
        getAllProductsForOrder()
        setIsNewOrderOpen(true)
    }

    function updateNewOrderField(field, value) {
        setNewOrderForm((prev) => ({
            ...prev,
            [field]: value
        }))
    }

    function addEmptyOrderProduct() {
        const tempId = `new-${Date.now()}`

        setNewOrderForm((prev) => ({
            ...prev,
            produse: [
                ...prev.produse,
                {
                    tempId,
                    produsId: null,
                    search: '',
                    nume: '',
                    selectedProductName: '',
                    codProdus: '',
                    serieProdus: '',
                    ean: '',
                    imagine: '',
                    garantie: '',
                    termenLivrare: '',
                    cantitate: 1,
                    furnizorId: '',
                    furnizorNume: '',
                    linkProdus: '',
                    pretFurnizor: '',
                    pretOfertat: '',
                    furnizori: []
                }
            ]
        }))
    }

    function removeOrderProduct(index) {
        setNewOrderForm((prev) => ({
            ...prev,
            produse: prev.produse.filter((_, productIndex) => productIndex !== index)
        }))
    }
    function toggleProductSuppliers(productKey) {
        setCollapsedSupplierSections((prev) => ({
            ...prev,
            [productKey]: !prev[productKey]
        }))
    }

    function updateOrderProduct(index, field, value) {
        setNewOrderForm((prev) => ({
            ...prev,
            produse: prev.produse.map((product, productIndex) =>
                productIndex === index
                    ? {
                        ...product,
                        [field]: value
                    }
                    : product
            )
        }))
    }
    function updateOrderProductSupplier(productIndex, supplierIndex, field, value) {
        setNewOrderForm((prev) => ({
            ...prev,
            produse: prev.produse.map((product, currentProductIndex) =>
                currentProductIndex === productIndex
                    ? {
                        ...product,
                        furnizori: (product.furnizori || []).map((supplier, currentSupplierIndex) =>
                            currentSupplierIndex === supplierIndex
                                ? {
                                    ...supplier,
                                    [field]: value
                                }
                                : supplier
                        )
                    }
                    : product
            )
        }))
    }
    function searchOrderProduct(index, value) {
        setNewOrderForm((prev) => ({
            ...prev,
            produse: prev.produse.map((product, productIndex) => {
                if (productIndex !== index) {
                    return product
                }

                const wasExistingProduct = product.produsId && value !== product.search

                if (wasExistingProduct) {
                    return {
                        ...product,
                        produsId: null,
                        search: value,
                        nume: value,
                        selectedProductName: '',
                        codProdus: '',
                        serieProdus: '',
                        ean: '',
                        imagine: '',
                        garantie: '',
                        termenLivrare: '',
                        furnizorId: '',
                        furnizorNume: '',
                        linkProdus: '',
                        pretFurnizor: ''
                    }
                }

                return {
                    ...product,
                    search: value,
                    nume: value
                }
            })
        }))

        const cleanValue = value.trim().toLowerCase()

        if (cleanValue.length < 2) {
            setProductSearchResults((prev) => ({
                ...prev,
                [index]: []
            }))
            return
        }

        const results = allProducts
            .filter((product) => {
                const searchableText = [
                    product.nume,
                    product.cod_produs,
                    product.serie_produs,
                    product.ean
                ]
                    .filter(Boolean)
                    .join(' ')
                    .toLowerCase()

                return searchableText.includes(cleanValue)
            })
            .slice(0, 30)

        setProductSearchResults((prev) => ({
            ...prev,
            [index]: results
        }))
    }

    function selectOrderProduct(index, product) {
        const productSuppliers = Array.isArray(product.furnizori) ? product.furnizori : []
        const firstSupplier = productSuppliers[0] || {}

        setNewOrderForm((prev) => ({
            ...prev,
            produse: prev.produse.map((item, productIndex) =>
                productIndex === index
                    ? {
                        ...item,
                        produsId: product.id,
                        search: product.nume || '',
                        nume: product.nume || '',
                        codProdus: product.cod_produs || '',
                        serieProdus: product.serie_produs || '',
                        ean: product.ean || '',
                        imagine: product.imagine || '',
                        garantie: product.garantie || '',
                        termenLivrare: product.termen_livrare || '',
                        furnizorId: firstSupplier.furnizor_id || '',
                        furnizorNume: firstSupplier.furnizor_nume || '',
                        linkProdus: firstSupplier.link_produs || '',
                        pretFurnizor: firstSupplier.pret_furnizor || '',
                        furnizori: productSuppliers.map((supplier) => ({
                            furnizorId: supplier.furnizor_id || '',
                            furnizorNume: supplier.furnizor_nume || '',
                            furnizorLogo: supplier.furnizor_logo || '',
                            linkProdus: supplier.link_produs || '',
                            pretFurnizor: supplier.pret_furnizor || '',
                            cantitateDisponibila: supplier.cantitate_disponibila ?? ''
                        }))
                    }
                    : item
            )
        }))

        setProductSearchResults((prev) => ({
            ...prev,
            [index]: []
        }))
    }

    async function saveNewOrder() {
        try {
            setSavingOrder(true)
            const payload = {
                clientId: client.id,
                contactId: newOrderForm.contactId || null,
                adresaId: newOrderForm.adresaId || null,
                numeComanda: newOrderForm.numeComanda,
                data: newOrderForm.data,
                ora: newOrderForm.ora,
                notite: newOrderForm.notite,
                produse: newOrderForm.produse
                    .filter((product) => product.nume.trim())
                    .map((product) => ({
                        produsId: product.produsId || null,
                        nume: product.nume || '',
                        codProdus: product.codProdus || '',
                        serieProdus: product.serieProdus || '',
                        ean: product.ean || '',
                        imagine: product.imagine || '',
                        garantie: product.garantie || '',
                        termenLivrare: product.termenLivrare || '',
                        cantitate: Number(product.cantitate || 1),
                        furnizorId: product.furnizorId || null,
                        furnizorNume: product.furnizorNume || '',
                        linkProdus: product.linkProdus || '',
                        pretFurnizor: product.pretFurnizor || null,
                        pretOfertat: product.pretOfertat || null,
                        furnizori: Array.isArray(product.furnizori) ? product.furnizori : []
                    }))
            }

            const response = await fetch(SAVE_ORDER_FULL_API_URL, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            })

            const data = await response.json()

            if (!response.ok || !data.success) {
                throw new Error(data.message || 'Save order failed')
            }

            await getClient()
            setIsNewOrderOpen(false)
        } catch (err) {
            console.error('SAVE ORDER ERROR:', err)
            alert(err.message || 'Nu am putut salva comanda.')
        } finally {
            setSavingOrder(false)
        }
    }

    async function getAllProductsForOrder() {
        try {
            const response = await fetch(GET_PRODUCTS_API_URL, {
                method: 'GET'
            })

            const data = await response.json()

            if (!response.ok) {
                throw new Error('Get products failed')
            }

            setAllProducts(Array.isArray(data.products) ? data.products : data.produse || [])
        } catch (err) {
            console.error('GET ALL PRODUCTS FOR ORDER ERROR:', err)
            setAllProducts([])
        }
    }

    function updateDateRange(value) {
        if (!dateRange.start || dateRange.end) {
            setDateRange({ start: value, end: '' })
            return
        }

        if (value < dateRange.start) {
            setDateRange({ start: value, end: dateRange.start })
            setIsDatePickerOpen(false)
            return
        }

        setDateRange({ start: dateRange.start, end: value })
        setIsDatePickerOpen(false)
    }

    function clearDateRange() {
        setDateRange({ start: '', end: '' })
    }

    function getDateRangeLabel() {
        if (dateRange.start && dateRange.end) {
            return `${dateRange.start} → ${dateRange.end}`
        }

        if (dateRange.start) {
            return `${dateRange.start} → alege final`
        }

        return 'Calendar'
    }
    const calendarYear = calendarMonth.getFullYear()
    const calendarMonthIndex = calendarMonth.getMonth()

    const firstDayOfMonth = new Date(calendarYear, calendarMonthIndex, 1)
    const lastDayOfMonth = new Date(calendarYear, calendarMonthIndex + 1, 0)

    const startWeekDay = firstDayOfMonth.getDay() === 0 ? 6 : firstDayOfMonth.getDay() - 1
    const daysInMonth = lastDayOfMonth.getDate()

    const calendarDays = [
        ...Array.from({ length: startWeekDay }, () => null),
        ...Array.from({ length: daysInMonth }, (_, index) => {
            const date = new Date(calendarYear, calendarMonthIndex, index + 1)
            return date.toISOString().slice(0, 10)
        })
    ]
    return (
        <section className="clientDetailsPage">
            <div className="clientBreadcrumb">
                <button type="button" onClick={() => navigate('/clienti')}>
                    Clienți
                </button>
                <span>›</span>
                <strong>{client.nume}</strong>
            </div>

            <div className="clientTop">
                <div className="clientIdentity">
                    <div className="clientDetailsLogo">

                        {client.logo ? (
                            <img
                                src={client.logo}
                                alt={client.nume}
                            />
                        ) : (
                            <span>{getInitials(client.nume)}</span>
                        )}
                    </div>

                    <div className="clientHeaderInfo">
                        <div className="clientTitleRow">
                            <h1>{client.nume}</h1>

                            <button
                                type="button"
                                className="editClientButton"
                                onClick={openEditClientModal}
                                aria-label="Editează client"
                            >
                                <svg viewBox="0 0 24 24">
                                    <path d="M3 17.25V21h3.75L17.8 9.95l-3.75-3.75L3 17.25Zm17.7-10.2c.4-.4.4-1 0-1.4l-2.35-2.35a1 1 0 0 0-1.4 0l-1.85 1.85 3.75 3.75 1.85-1.85Z" />
                                </svg>
                            </button>
                        </div>

                        <div className="clientMetaRow">
                            <span className="clientMetaBadge">
                                CUI {client.cui || '-'}
                            </span>

                            {client.website && (
                                <a
                                    href={client.website}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="clientWebsite"
                                >
                                    Website
                                </a>
                            )}
                        </div>
                    </div>
                </div>

                <button
                    className="newOfferButton"
                    type="button"
                    onClick={openNewOrderModal}
                >
                    + Comandă nouă
                </button>
            </div>

            <div className="clientSummaryGrid">
                <div className="clientSummaryCard">
                    <div className="summaryTitle">
                        <span>👥</span>
                        <h2>Contacte</h2>
                        <button
                            type="button"
                            className="summaryEditButton"
                            onClick={openEditContactsModal}
                            aria-label="Editează contacte"
                        >
                            <svg viewBox="0 0 24 24">
                                <path d="M3 17.25V21h3.75L17.8 9.95l-3.75-3.75L3 17.25Zm17.7-10.2c.4-.4.4-1 0-1.4l-2.35-2.35a1 1 0 0 0-1.4 0l-1.85 1.85 3.75 3.75 1.85-1.85Z" />
                            </svg>
                        </button>
                    </div>

                    <div className="summaryList">
                        {client.contacte?.map((contact) => (
                            <div className="contactRow" key={contact.id}>
                                <div className="contactAvatar">
                                    {getInitials(contact.nume)}
                                </div>

                                <div className="contactMain">
                                    <strong>{contact.nume}</strong>
                                    <span>{contact.functie || 'Funcție lipsă'}</span>
                                </div>

                                <div className="contactMeta">
                                    <div className="contactInfoRow">
                                        <svg className="contactSvgIcon" viewBox="0 0 24 24">
                                            <path d="M20 4H4C2.9 4 2 4.9 2 6v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2Zm0 4-8 5-8-5V6l8 5 8-5v2Z" />
                                        </svg>
                                        <span>{contact.email || '-'}</span>
                                    </div>

                                    <div className="contactInfoRow">
                                        <svg className="contactSvgIcon" viewBox="0 0 24 24">
                                            <path d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.8-.4 1.2-.3 1.3.4 2.7.6 4.1.6.7 0 1.3.6 1.3 1.3v3.5c0 .7-.6 1.3-1.3 1.3C10.3 21.6 2.4 13.7 2.4 3.3 2.4 2.6 3 2 3.7 2h3.5c.7 0 1.3.6 1.3 1.3 0 1.4.2 2.8.6 4.1.1.4 0 .9-.3 1.2l-2.2 2.2Z" />
                                        </svg>
                                        <span>{contact.telefon || '-'}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="clientSummaryCard">
                    <div className="summaryTitle">
                        <span>📍</span>
                        <h2>Adrese de livrare</h2>
                        <button
                            type="button"
                            className="summaryEditButton"
                            onClick={openEditAddressesModal}
                            aria-label="Editează adrese"
                        >
                            <svg viewBox="0 0 24 24">
                                <path d="M3 17.25V21h3.75L17.8 9.95l-3.75-3.75L3 17.25Zm17.7-10.2c.4-.4.4-1 0-1.4l-2.35-2.35a1 1 0 0 0-1.4 0l-1.85 1.85 3.75 3.75 1.85-1.85Z" />
                            </svg>
                        </button>
                    </div>

                    <div className="summaryList">
                        {client.adrese?.map((adresa) => (
                            <div className="addressRow" key={adresa.id}>
                                <span>🏢</span>
                                <div>
                                    <strong>{adresa.nume || 'Adresă'}</strong>
                                    <p>{adresa.adresa}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="clientSummaryCard">
                    <div className="summaryTitle">
                        <span>📝</span>
                        <h2>Note despre client</h2>

                        <button
                            type="button"
                            className="summaryEditButton"
                            onClick={openEditClientModal}
                            aria-label="Editează client"
                        >
                            <svg viewBox="0 0 24 24">
                                <path d="M3 17.25V21h3.75L17.8 9.95l-3.75-3.75L3 17.25Zm17.7-10.2c.4-.4.4-1 0-1.4l-2.35-2.35a1 1 0 0 0-1.4 0l-1.85 1.85 3.75 3.75 1.85-1.85Z" />
                            </svg>
                        </button>
                    </div>
                    <p className="clientNotes">
                        {client.note || 'Nu există note pentru acest client.'}
                    </p>
                </div>
            </div>
            <div className="offersFilterHeader">
                <span> <strong>Filtrează după status</strong> sau </span>

                <div className="offersSearchInput">
                    <span>⌕</span>

                    <input
                        type="text"
                        placeholder="Caută comandă..."
                        value={orderSearch}
                        onChange={(event) => setOrderSearch(event.target.value)}
                        onKeyDown={(event) => {
                            if (event.key === 'Escape') {
                                setOrderSearch('')
                            }
                        }}
                    />

                    {orderSearch && (
                        <button
                            type="button"
                            className="searchClearButton"
                            onClick={() => setOrderSearch('')}
                        >
                            ×
                        </button>
                    )}
                </div>

                <div className="offersDateFilter">
                    <button
                        type="button"
                        className="offersDateButton"
                        onClick={() => setIsDatePickerOpen((prev) => !prev)}
                    >
                        {getDateRangeLabel()}
                    </button>

                    {isDatePickerOpen && (
                        <div className="offersCalendarPopover">
                            <div className="offersCalendarHeader">
                                <button
                                    type="button"
                                    onClick={() =>
                                        setCalendarMonth(
                                            new Date(calendarYear, calendarMonthIndex - 1, 1)
                                        )
                                    }
                                >
                                    ‹
                                </button>

                                <strong>
                                    {calendarMonth.toLocaleDateString('ro-RO', {
                                        month: 'long',
                                        year: 'numeric'
                                    })}
                                </strong>

                                <button
                                    type="button"
                                    onClick={() =>
                                        setCalendarMonth(
                                            new Date(calendarYear, calendarMonthIndex + 1, 1)
                                        )
                                    }
                                >
                                    ›
                                </button>
                            </div>

                            <div className="offersCalendarWeekdays">
                                <span>L</span>
                                <span>M</span>
                                <span>M</span>
                                <span>J</span>
                                <span>V</span>
                                <span>S</span>
                                <span>D</span>
                            </div>

                            <div className="offersCalendarGrid">
                                {calendarDays.map((day, index) => {
                                    if (!day) {
                                        return <span key={`empty-${index}`} />
                                    }

                                    const isStart = dateRange.start === day
                                    const isEnd = dateRange.end === day
                                    const isInside =
                                        dateRange.start &&
                                        dateRange.end &&
                                        day > dateRange.start &&
                                        day < dateRange.end

                                    return (
                                        <button
                                            type="button"
                                            key={day}
                                            className={[
                                                isStart ? 'rangeStart' : '',
                                                isEnd ? 'rangeEnd' : '',
                                                isInside ? 'rangeInside' : ''
                                            ].join(' ')}
                                            onClick={() => updateDateRange(day)}
                                        >
                                            {new Date(day).getDate()}
                                        </button>
                                    )
                                })}
                            </div>

                            <button
                                type="button"
                                className="offersCalendarClear"
                                onClick={clearDateRange}
                            >
                                Șterge perioada
                            </button>
                        </div>
                    )}
                </div>
            </div>

            <div className="offersToolbar">
                {[
                    ['toate', 'Toate'],
                    ['solicitare', 'Solicitare'],
                    ['ofertat', 'Ofertat'],
                    ['acceptat', 'Acceptat'],
                    ['asteptare_plata', 'Așteptare Plată'],
                    ['comanda_furnizor', 'Comandă furnizor'],
                    ['pregatire_colet', 'Pregătire Colet'],
                    ['expediat', 'Expediat'],
                    ['finalizat', 'Finalizat'],
                    ['refuzat', 'Refuzat'],

                ].map(([value, label]) => (
                    <button
                        type="button"
                        key={value}
                        className={activeFilter === value ? 'active' : ''}
                        onClick={() => setActiveFilter(value)}
                    >
                        {label}
                    </button>
                ))}
            </div>

            <div className="offersTable">
                <div className="offersTableHead">
                    <span>Nume comandă</span>
                    <span>ID comandă</span>
                    <span>Data și ora ultimului status</span>
                    <span>Status</span>
                    <span></span>
                </div>

                {filteredOffers.length === 0 && (
                    <div className="emptyOffers">
                        Nu există comenzi pentru acest client.
                    </div>
                )}

                {filteredOffers.map((offer) => (
                    <div
                        className="offerRow"
                        key={offer.id}
                        onClick={() => navigate(`/clienti/${clientSlug}/${offer.uuid}`)}
                        role="button"
                        tabIndex={0}
                    >
                        <span className="clientOfferName">
                            📄 {offer.nume_comanda}
                        </span>

                        <span className="clientOfferOrderId">
                            #{getOrderNumber(offer)}
                        </span>

                        <div className="clientOfferStatusDates">
                            <strong>
                                {formatDate(offer.latest_status_date)}
                            </strong>

                            <small>
                                Solicitare:{' '}
                                {formatDate(offer.solicitare_status_date)}
                            </small>
                        </div>

                        <div className={`statusPill status-${offer.status}`}>
                            <span>
                                {ORDER_STATUS_LABELS[offer.status] || offer.status}
                            </span>
                        </div>

                        <span className="clientOfferArrow">›</span>
                    </div>
                ))}
            </div>
            <Modal
                isOpen={isEditClientOpen}
                title="Editează client"
                onClose={() => setIsEditClientOpen(false)}
                footer={
                    <>
                        <button
                            type="button"
                            className="modalSecondaryButton"
                            onClick={() => setIsEditClientOpen(false)}
                        >
                            Anulează
                        </button>

                        <button
                            type="button"
                            className="modalPrimaryButton"
                            disabled={savingClient}
                            onClick={saveClient}
                        >
                            {savingClient ? 'Se salvează...' : 'Salvează client'}
                        </button>
                    </>
                }
            >
                <div className="clientDetailsEditModal">
                    <div className="clientDetailsEditCard">
                        <div className="clientDetailsEditLogoPanel">
                            <span className="clientDetailsEditLabel">Logo companie</span>

                            <button
                                type="button"
                                className="clientDetailsEditLogoDrop"
                                onClick={() => logoFileInputRef.current?.click()}
                            >
                                {editClientForm.logo ? (
                                    <img src={editClientForm.logo} alt="Logo preview" />
                                ) : (
                                    <svg viewBox="0 0 24 24">
                                        <path d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2ZM8.5 11.5l2.5 3.01L14.5 10l4.5 6H5l3.5-4.5Z" />
                                    </svg>
                                )}
                            </button>

                            <input
                                ref={logoFileInputRef}
                                type="file"
                                accept="image/*"
                                style={{ display: 'none' }}
                                onChange={handleLocalLogoChange}
                            />

                            <button
                                type="button"
                                className="clientDetailsEditGhostButton"
                                onClick={() => logoFileInputRef.current?.click()}
                            >
                                Încarcă logo
                            </button>

                            <div className="clientDetailsEditIconInput">
                                <svg viewBox="0 0 24 24">
                                    <path d="M3.9 12a5 5 0 0 1 5-5h4v2h-4a3 3 0 0 0 0 6h4v2h-4a5 5 0 0 1-5-5Zm6.1 1v-2h4v2h-4Zm1-6h4a5 5 0 0 1 0 10h-4v-2h4a3 3 0 0 0 0-6h-4V7Z" />
                                </svg>

                                <input
                                    type="text"
                                    placeholder="Link logo companie"
                                    value={editClientForm.logo || ''}
                                    onChange={(event) =>
                                        setEditClientForm((prev) => ({
                                            ...prev,
                                            logo: event.target.value
                                        }))
                                    }
                                />
                            </div>
                        </div>

                        <div className="clientDetailsEditMainPanel">
                            <label className="clientDetailsEditField">
                                <span>Nume client</span>
                                <input
                                    type="text"
                                    value={editClientForm.nume}
                                    onChange={(event) =>
                                        setEditClientForm((prev) => ({
                                            ...prev,
                                            nume: event.target.value
                                        }))
                                    }
                                />
                            </label>

                            <div className="clientDetailsEditTwoGrid">
                                <label className="clientDetailsEditField">
                                    <span>CUI</span>
                                    <input
                                        type="text"
                                        value={editClientForm.cui}
                                        onChange={(event) =>
                                            setEditClientForm((prev) => ({
                                                ...prev,
                                                cui: event.target.value
                                            }))
                                        }
                                    />
                                </label>

                                <label className="clientDetailsEditField">
                                    <span>Website</span>
                                    <input
                                        type="text"
                                        placeholder="www.company.com"
                                        value={editClientForm.website}
                                        onChange={(event) =>
                                            setEditClientForm((prev) => ({
                                                ...prev,
                                                website: event.target.value
                                            }))
                                        }
                                    />
                                </label>
                            </div>

                            <label className="clientDetailsEditField">
                                <span>Note</span>
                                <textarea
                                    value={editClientForm.note}
                                    onChange={(event) =>
                                        setEditClientForm((prev) => ({
                                            ...prev,
                                            note: event.target.value
                                        }))
                                    }
                                />
                            </label>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal
                isOpen={isEditContactsOpen}
                title="Editează contacte"
                onClose={() => setIsEditContactsOpen(false)}
                footer={
                    <>
                        <button
                            type="button"
                            className="modalSecondaryButton"
                            onClick={() => setIsEditContactsOpen(false)}
                        >
                            Anulează
                        </button>

                        <button
                            type="button"
                            className="modalPrimaryButton"
                            disabled={savingContacts}
                            onClick={saveContacts}
                        >
                            {savingContacts ? 'Se salvează...' : 'Salvează contacte'}
                        </button>
                    </>
                }
            >
                <div className="contactsEditForm">
                    {editContactsForm.filter((contact) => !contact.deleted).map((contact, index) => (
                        <div className="contactEditBox" key={contact.id || `new-${index}`}>
                            <div className="contactEditHeader">
                                <strong>Contact {index + 1}</strong>

                                <button
                                    type="button"
                                    className="deleteContactButton"
                                    onClick={() => deleteContactForm(index)}
                                >
                                    -
                                </button>
                            </div>

                            <div className="contactEditRow">
                                <label>
                                    <span>Nume</span>
                                    <input
                                        type="text"
                                        value={contact.nume}
                                        onChange={(event) => updateContactForm(index, 'nume', event.target.value)}
                                    />
                                </label>

                                <label>
                                    <span>Funcție</span>
                                    <input
                                        type="text"
                                        value={contact.functie}
                                        onChange={(event) => updateContactForm(index, 'functie', event.target.value)}
                                    />
                                </label>
                            </div>

                            <div className="contactEditRow">
                                <label>
                                    <span>Email</span>
                                    <input
                                        type="email"
                                        value={contact.email}
                                        onChange={(event) => updateContactForm(index, 'email', event.target.value)}
                                    />
                                </label>

                                <label>
                                    <span>Telefon</span>
                                    <input
                                        type="text"
                                        value={contact.telefon}
                                        onChange={(event) => updateContactForm(index, 'telefon', event.target.value)}
                                    />
                                </label>
                            </div>
                        </div>
                    ))}

                    <button
                        type="button"
                        className="addContactButton"
                        onClick={addContactForm}
                    >
                        + Adaugă contact
                    </button>
                </div>
            </Modal>
            <Modal
                isOpen={isEditAddressesOpen}
                title="Editează adrese de livrare"
                onClose={() => setIsEditAddressesOpen(false)}
                footer={
                    <>
                        <button
                            type="button"
                            className="modalSecondaryButton"
                            onClick={() => setIsEditAddressesOpen(false)}
                        >
                            Anulează
                        </button>

                        <button
                            type="button"
                            className="modalPrimaryButton"
                            disabled={savingAddresses}
                            onClick={saveAddresses}
                        >
                            {savingAddresses ? 'Se salvează...' : 'Salvează adrese'}
                        </button>
                    </>
                }
            >
                <div className="addressesEditForm">
                    {editAddressesForm.filter((adresa) => !adresa.deleted).map((adresa, index) => (
                        <div className="addressEditBox" key={adresa.id || `new-address-${index}`}>
                            <div className="addressEditHeader">
                                <strong>Adresă {index + 1}</strong>

                                <button
                                    type="button"
                                    className="deleteContactButton"
                                    onClick={() => deleteAddressForm(index)}
                                >
                                    -
                                </button>
                            </div>

                            <label>
                                <span>Nume</span>
                                <input
                                    type="text"
                                    value={adresa.nume}
                                    onChange={(event) => updateAddressForm(index, 'nume', event.target.value)}
                                />
                            </label>

                            <label>
                                <span>Adresă</span>
                                <textarea
                                    value={adresa.adresa}
                                    onChange={(event) => updateAddressForm(index, 'adresa', event.target.value)}
                                />
                            </label>
                        </div>
                    ))}

                    <button
                        type="button"
                        className="addContactButton"
                        onClick={addAddressForm}
                    >
                        + Adaugă adresă
                    </button>
                </div>
            </Modal>
            <BigModal
                isOpen={isNewOrderOpen}
                title="Adaugă comandă nouă"
                onClose={() => setIsNewOrderOpen(false)}
                footer={
                    <>
                        <button
                            type="button"
                            className="modalSecondaryButton"
                            onClick={() => setIsNewOrderOpen(false)}
                        >
                            Anulează
                        </button>

                        <button
                            type="button"
                            className="modalPrimaryButton"
                            disabled={savingOrder}
                            onClick={saveNewOrder}
                        >
                            {savingOrder ? 'Se salvează...' : 'Salvează comanda'}
                        </button>
                    </>
                }
            >
                <div className="orderPremiumModal">
                    <div className="orderPremiumCard orderPremiumInfoCard">
                        <div className="orderPremiumStripeHeader">
                            <div className="orderPremiumSectionIcon orderPremiumBlueIcon">
                                <svg viewBox="0 0 24 24">
                                    <path d="M4 4h16v16H4V4Zm2 2v12h12V6H6Zm2 2h8v2H8V8Zm0 4h8v2H8v-2Z" />
                                </svg>
                            </div>

                            <h3>Informații comandă</h3>
                        </div>

                        <div className="orderPremiumTopGrid">
                            <label className="orderPremiumField">
                                <span>Nume comandă</span>
                                <div className="orderPremiumIconInput">
                                    <svg viewBox="0 0 24 24">
                                        <path d="M4 4h16v16H4V4Zm3 4h10v2H7V8Zm0 4h10v2H7v-2Z" />
                                    </svg>

                                    <input
                                        type="text"
                                        value={newOrderForm.numeComanda}
                                        onChange={(event) => updateNewOrderField('numeComanda', event.target.value)}
                                    />
                                </div>
                            </label>

                            <label className="orderPremiumField">
                                <span>Data</span>
                                <div className="orderPremiumIconInput">
                                    <svg viewBox="0 0 24 24">
                                        <path d="M7 2h2v2h6V2h2v2h3v18H4V4h3V2Zm13 8H4v10h16V10Z" />
                                    </svg>

                                    <input
                                        type="date"
                                        value={newOrderForm.data}
                                        onChange={(event) => updateNewOrderField('data', event.target.value)}
                                    />
                                </div>
                            </label>

                            <label className="orderPremiumField">
                                <span>Ora</span>
                                <div className="orderPremiumIconInput">
                                    <svg viewBox="0 0 24 24">
                                        <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm1 5h-2v6l5 3 1-1.73-4-2.27V7Z" />
                                    </svg>

                                    <input
                                        type="time"
                                        value={newOrderForm.ora}
                                        onChange={(event) => updateNewOrderField('ora', event.target.value)}
                                    />
                                </div>
                            </label>

                            <label className="orderPremiumField">
                                <span>Agent</span>
                                <div className="orderPremiumIconInput">
                                    <svg viewBox="0 0 24 24">
                                        <path d="M12 12a5 5 0 1 0-5-5 5 5 0 0 0 5 5Zm0 2c-4.42 0-8 2.24-8 5v1h16v-1c0-2.76-3.58-5-8-5Z" />
                                    </svg>

                                    <select
                                        value={newOrderForm.contactId}
                                        onChange={(event) => updateNewOrderField('contactId', event.target.value)}
                                    >
                                        <option value="">Alege agent</option>
                                        {client.contacte?.map((contact) => (
                                            <option key={contact.id} value={contact.id}>
                                                {contact.nume} {contact.functie ? `- ${contact.functie}` : ''}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </label>

                            <label className="orderPremiumField orderPremiumAddressField">
                                <span>Adresă livrare</span>
                                <div className="orderPremiumIconInput">
                                    <svg viewBox="0 0 24 24">
                                        <path d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5Z" />
                                    </svg>

                                    <select
                                        value={newOrderForm.adresaId}
                                        onChange={(event) => updateNewOrderField('adresaId', event.target.value)}
                                    >
                                        <option value="">Alege adresă</option>
                                        {client.adrese?.map((adresa) => (
                                            <option key={adresa.id} value={adresa.id}>
                                                {adresa.nume || 'Adresă'} - {adresa.adresa}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </label>
                        </div>

                        <label className="orderPremiumField orderPremiumNoteField">
                            <span>Notițe comandă</span>
                            <textarea
                                rows="1"
                                value={newOrderForm.notite}
                                onChange={(event) => updateNewOrderField('notite', event.target.value)}
                                placeholder="Adaugă o notă despre comandă..."
                            />
                        </label>
                    </div>

                    <div className="orderPremiumCard orderPremiumProductsCard">




                        <div className="orderPremiumStripeHeader">
                            <div className="orderPremiumSectionIcon orderPremiumBlueIcon">
                                <svg viewBox="0 0 24 24">
                                    <path d="M21 8.5 12 3 3 8.5l9 5.5 9-5.5ZM5 10.2V16l7 4.3V14.5L5 10.2Zm14 0-7 4.3v5.8l7-4.3v-5.8Z" />
                                </svg>
                            </div>

                            <h3>Produse</h3>

                            <button
                                type="button"
                                className="orderPremiumAddButton orderPremiumBlueAddButton"
                                onClick={addEmptyOrderProduct}
                            >
                                + Adaugă produs
                            </button>
                        </div>

                        {newOrderForm.produse.length > 0 && (
                            <div className="orderPremiumProductsOfertaHead">
                                <span>Produs</span>
                                <span>Cod produs</span>
                                <span>EAN</span>
                                <span>Cantitate</span>
                                <span>Cost achiziție</span>
                                <span>Preț final ofertat</span>
                                <span></span>
                            </div>
                        )}

                        <div className="orderPremiumOfertaRows">
                            {newOrderForm.produse.map((product, index) => (
                                <div className="orderPremiumOfertaProductCard" key={product.tempId}>
                                    <div className="orderPremiumOfertaProductRow">
                                        <label className="orderPremiumProductSearchCell">
                                            <div className="orderPremiumOfertaProductIdentity">
                                                <div className="orderPremiumOfertaProductImage">
                                                    {product.imagine ? (
                                                        <img src={product.imagine} alt={product.search || 'Produs'} />
                                                    ) : (
                                                        <span>{String(product.search || '?').charAt(0).toUpperCase()}</span>
                                                    )}
                                                </div>

                                                <div className="productSmartSearch">
                                                    <input
                                                        className="productLightInput productNameInput"
                                                        type="text"
                                                        value={product.search}
                                                        onChange={(event) => searchOrderProduct(index, event.target.value)}
                                                        placeholder="Caută produs..."
                                                        autoComplete="off"
                                                    />

                                                    {product.search.trim().length >= 2 && productSearchResults[index]?.length > 0 && (
                                                        <div className="productSmartDropdown">
                                                            {productSearchResults[index].map((result) => (
                                                                <button
                                                                    type="button"
                                                                    key={result.id}
                                                                    onClick={() => selectOrderProduct(index, result)}
                                                                >
                                                                    <div className="productSmartImage">
                                                                        {result.imagine ? (
                                                                            <img src={result.imagine} alt={result.nume} />
                                                                        ) : (
                                                                            <span>{String(result.nume || '?').charAt(0).toUpperCase()}</span>
                                                                        )}
                                                                    </div>

                                                                    <div className="productSmartInfo">
                                                                        <strong>{result.nume}</strong>
                                                                        <small>
                                                                            {result.cod_produs || '-'} | {result.ean || '-'} | {result.serie_produs || '-'}
                                                                        </small>
                                                                    </div>
                                                                </button>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </label>

                                        <input
                                            className="productLightInput"
                                            type="text"
                                            value={product.codProdus}
                                            onChange={(event) => updateOrderProduct(index, 'codProdus', event.target.value)}
                                        />

                                        <input
                                            className="productLightInput"
                                            type="text"
                                            value={product.ean}
                                            onChange={(event) => updateOrderProduct(index, 'ean', event.target.value)}
                                        />

                                        <input
                                            className="productLightInput"
                                            type="number"
                                            min="1"
                                            value={product.cantitate}
                                            onChange={(event) => updateOrderProduct(index, 'cantitate', event.target.value)}
                                        />

                                        <input
                                            className="productLightInput"
                                            type="number"
                                            step="0.01"
                                            value={product.pretFurnizor}
                                            onChange={(event) => updateOrderProduct(index, 'pretFurnizor', event.target.value)}
                                        />

                                        <input
                                            className="productLightInput moneyInput"
                                            type="number"
                                            step="0.01"
                                            value={product.pretOfertat}
                                            onChange={(event) => updateOrderProduct(index, 'pretOfertat', event.target.value)}
                                        />

                                        <button
                                            type="button"
                                            className="orderPremiumCollapseButton"
                                            onClick={() => toggleProductSuppliers(product.tempId)}
                                            title={
                                                collapsedSupplierSections[product.tempId]
                                                    ? 'Arată furnizorii'
                                                    : 'Ascunde furnizorii'
                                            }
                                        >
                                            <svg
                                                viewBox="0 0 24 24"
                                                className={
                                                    collapsedSupplierSections[product.tempId]
                                                        ? 'collapsed'
                                                        : ''
                                                }
                                            >
                                                <path d="M7.4 9.4 12 14l4.6-4.6L18 10.8l-6 6-6-6z" />
                                            </svg>
                                        </button>

                                        <button
                                            type="button"
                                            className="orderPremiumRemoveButton"
                                            onClick={() => removeOrderProduct(index)}
                                        >
                                            <svg viewBox="0 0 24 24">
                                                <path d="M6 19a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7H6v12ZM8 4l1-1h6l1 1h4v2H4V4h4Z" />
                                            </svg>
                                        </button>
                                    </div>

                                    {Array.isArray(product.furnizori) &&
                                        product.furnizori.length > 0 &&
                                        !collapsedSupplierSections[product.tempId] && (
                                            <div className="orderPremiumOfertaSuppliersBox">
                                                <div className="orderPremiumOfertaSuppliersTitle">
                                                    <strong>Furnizori ({product.furnizori.length})</strong>
                                                </div>

                                                <div className="orderPremiumOfertaSuppliersTable">
                                                    <div className="orderPremiumOfertaSuppliersGrid orderPremiumOfertaSuppliersHead">
                                                        <span>Furnizor</span>
                                                        <span>Link produs furnizor</span>
                                                        <span>Stoc disponibil</span>
                                                        <span>Preț furnizor</span>
                                                    </div>

                                                    {product.furnizori.map((supplier, supplierIndex) => (
                                                        <div className="orderPremiumOfertaSuppliersGrid" key={`${supplier.furnizorId}-${supplierIndex}`}>
                                                            <div className="productSupplierIdentity">
                                                                <div className="productSupplierLogo">
                                                                    {supplier.logo || supplier.furnizorLogo || supplier.furnizor_logo ? (
                                                                        <img
                                                                            src={supplier.logo || supplier.furnizorLogo || supplier.furnizor_logo}
                                                                            alt={supplier.furnizorNume || 'Furnizor'}
                                                                        />
                                                                    ) : (
                                                                        <span>{String(supplier.furnizorNume || '?').charAt(0).toUpperCase()}</span>
                                                                    )}
                                                                </div>

                                                                <input
                                                                    className="supplierLightInput"
                                                                    type="text"
                                                                    value={supplier.furnizorNume}
                                                                    onChange={(event) =>
                                                                        updateOrderProductSupplier(index, supplierIndex, 'furnizorNume', event.target.value)
                                                                    }
                                                                />
                                                            </div>
                                                            <div className="supplierLinkInput">
                                                                <button
                                                                    type="button"
                                                                    className="supplierLinkButton"
                                                                    onClick={() => {
                                                                        if (supplier.linkProdus) {
                                                                            window.open(supplier.linkProdus, '_blank', 'noopener,noreferrer')
                                                                        }
                                                                    }}
                                                                    disabled={!supplier.linkProdus}
                                                                    title="Deschide link produs"
                                                                >
                                                                    <svg
                                                                        viewBox="0 0 24 24"
                                                                        width="14"
                                                                        height="14"
                                                                        fill="none"
                                                                        stroke="currentColor"
                                                                        strokeWidth="2"
                                                                    >
                                                                        <path d="M14 3h7v7" />
                                                                        <path d="M10 14L21 3" />
                                                                        <path d="M21 14v4a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h4" />
                                                                    </svg>
                                                                </button>

                                                                <input
                                                                    className="supplierLightInput"
                                                                    type="text"
                                                                    value={supplier.linkProdus}
                                                                    onChange={(event) =>
                                                                        updateOrderProductSupplier(index, supplierIndex, 'linkProdus', event.target.value)
                                                                    }
                                                                />
                                                            </div>

                                                            <input
                                                                className="supplierLightInput"
                                                                type="text"
                                                                value={supplier.cantitateDisponibila}
                                                                onChange={(event) =>
                                                                    updateOrderProductSupplier(index, supplierIndex, 'cantitateDisponibila', event.target.value)
                                                                }
                                                            />

                                                            <input
                                                                className="supplierLightInput"
                                                                type="number"
                                                                step="0.01"
                                                                value={supplier.pretFurnizor}
                                                                onChange={(event) =>
                                                                    updateOrderProductSupplier(index, supplierIndex, 'pretFurnizor', event.target.value)
                                                                }
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                </div>
                            ))}

                            {newOrderForm.produse.length === 0 && (
                                <button
                                    type="button"
                                    className="emptyProductButton"
                                    onClick={addEmptyOrderProduct}
                                >
                                    + Adaugă primul produs
                                </button>
                            )}
                        </div>

                    </div>
                </div>
            </BigModal>
        </section>
    )
}

export default ClientsDetails